import { absolutePath } from "../absolutePath";

export const communityMembers = {
  show: (id: number) => absolutePath(`access_registry/community_members/${id}`),
  grant: (id: number) =>
    absolutePath(`access_registry/community_members/${id}/grant`),
  revoke: (id: number) =>
    absolutePath(`access_registry/community_members/${id}/revoke`),
};
